import { registerPlugin } from '@capacitor/core';
const BackgroundTask = registerPlugin('BackgroundTask', {
    web: () => import('./web').then(m => new m.BackgroundTaskWeb()),
});
export * from './definitions';
export { BackgroundTask };
//# sourceMappingURL=index.js.map